import { DefectCategories, DefectTypes } from 'Modules/types/pages/imageReview/enums'

const MARKER_STROKE_COLOR = '#90D7FF'
const MARKER_MEASUREMENT_STROKE_COLOR = '#90D7FF'
const MARKER_HOVER_STROKE_COLOR = '#ffedd5'
const MARKER_SELECTED_STROKE_COLOR = '#F39D22'
const MARKER_MEASUREMENT_HOVERED_STROKE_WEIGHT = 5
const MARKER_STROKE_WEIGHT = 2.5

const DAMAGE_TYPE_STROKE_COLOR = {
  [DefectCategories.paint_defect]: '#FF00FF',
  [DefectCategories.seal]: '#9ACD32',
  [DefectCategories.hardware]: '#8A2BE2',
  [DefectCategories.other]: '#FFA500',
  [DefectCategories.composite]: '#00FFFF',
}

const DEFECT_CATEGORY_LOOKUP: Record<DefectTypes, DefectCategories> = {
  [DefectTypes.composite]: DefectCategories.composite,
  [DefectTypes.paint_defect]: DefectCategories.paint_defect,
  [DefectTypes.minor_paint_defect]: DefectCategories.paint_defect,
  [DefectTypes.missing_fasteners]: DefectCategories.hardware,
  [DefectTypes.scratch]: DefectCategories.paint_defect,
  [DefectTypes.gouge]: DefectCategories.paint_defect,
  [DefectTypes.corrosion]: DefectCategories.paint_defect,
  [DefectTypes.seal_damage]: DefectCategories.seal,
  [DefectTypes.fluid_leak]: DefectCategories.other,
  [DefectTypes.hardware]: DefectCategories.hardware,
  [DefectTypes.seal]: DefectCategories.seal,
  [DefectTypes.sealant_damage]: DefectCategories.seal,
  [DefectTypes.composite_damage]: DefectCategories.composite,
  [DefectTypes.missing_damaged_part]: DefectCategories.hardware,
  [DefectTypes.cracks]: DefectCategories.other,
  [DefectTypes.dent]: DefectCategories.other,
  [DefectTypes.punctures_holes]: DefectCategories.other,
  [DefectTypes.lightning_strike]: DefectCategories.other,
  [DefectTypes.bird_strike]: DefectCategories.other,
  [DefectTypes.other]: DefectCategories.other,
}

export {
  DAMAGE_TYPE_STROKE_COLOR,
  MARKER_STROKE_COLOR,
  MARKER_STROKE_WEIGHT,
  MARKER_HOVER_STROKE_COLOR,
  MARKER_SELECTED_STROKE_COLOR,
  MARKER_MEASUREMENT_STROKE_COLOR,
  MARKER_MEASUREMENT_HOVERED_STROKE_WEIGHT,
  DEFECT_CATEGORY_LOOKUP,
}
